import z from 'zod'
import {
  nullSafeOptionalBoolean,
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalString,
  nullSafeString,
  nullSafeStringArray,
} from '../shared/schema'
import { promptTypeFieldLabels, promptVersionPromptFields } from '../../types'

const uniqueFields = [
  'tool0Description',
  'tool1Description',
  'tool2Description',
]

export const schema = z.object({
  title: nullSafeString(''),
  description: nullSafeString(''),
  fieldLabels: z.record(z.enum(promptTypeFieldLabels), z.string()).default({}),
  requiredPrompts: z
    .array(z.enum([...promptVersionPromptFields, ...uniqueFields]))
    .default([]),
  optionalPrompts: z
    .array(z.enum([...promptVersionPromptFields, ...uniqueFields]))
    .default([]),
  requiredFields: nullSafeStringArray([]),
  promptType: z.literal('post_assignment_prompt'),
  promptSchemas: z
    .record(z.enum(promptVersionPromptFields), z.string())
    .default({}),
  tools: z.record(z.string(), z.string()),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
  showTestingTab: nullSafeOptionalBoolean(false),
  trigger: nullSafeOptionalString(),
})

export const empty = Object.freeze(
  schema.parse({
    promptType: 'post_assignment_prompt',
    requiredPrompts: [],
    optionalPrompts: [],
    tools: {},
  })
)

export type FirestorePromptPostAssignmentType = z.infer<typeof schema>
